import React from "react";
import { useSelector } from "react-redux";
import { Route, Switch } from "react-router-dom";
import { ConfigProvider } from "antd";
import AuthService from "../util/auth.service";
import AppLocale from "../languageProvider";
import { publicStandaloneRoutes } from "./constant";

const AuthenticatedAppRoutes = React.lazy(() => import("../routes/authenticated-app-routes"));
const UnAuthenticatedAppRoutes = React.lazy(() => import("../routes/unauthenticated-app-routes"));
const SurveyPacketView = React.lazy(() => import("../containers/SurveyPacketView/SurveyPacketView"));

const Routes = () => {
    const locale = useSelector(({ settings }) => settings.locale);
    const isTokenExist = AuthService.isTokenExist();
    const currentAppLocale = AppLocale.find((x) => x.id === locale);

    return (
        <ConfigProvider locale={currentAppLocale.lang.antdLocale}>
            <Switch>
                {/* Standalone pages sit ABOVE the authenticated / unauthenticated
                    split on purpose. A survey packet link is handed to an outside
                    surveyor, so it must render as its own page with no sidebar or
                    topbar — and it must look identical whether or not the person
                    opening it happens to be a logged-in staff member. Putting it
                    inside AuthenticatedApp wrapped it in <MainApp>, which is what
                    made a shared link open "inside the system". */}
                <Route exact path={publicStandaloneRoutes.SURVEY_PACKET_VIEW} component={SurveyPacketView} />
                <Route
                    path="*"
                    render={() => (isTokenExist ? <AuthenticatedAppRoutes /> : <UnAuthenticatedAppRoutes />)}
                />
            </Switch>
        </ConfigProvider>
    );
};

export default Routes;
